export const LOAD_APPOINTMENTS = 'LOAD_APPOINTMENTS'
export const SET_CURRENT_APPOINTMENT = 'SET_CURRENT_APPOINTMENT'
export const ADD_APPOINTMENT = 'ADD_APPOINTMENT'
export const LOAD_APPOINTMENT_STATUS = 'LOAD_APPOINTMENT_STATUS'
export const LOAD_APPOINTMENT_REMINDER_STATUS = 'LOAD_APPOINTMENT_REMINDER_STATUS'
export const LOAD_TIME_ZONES = 'LOAD_TIME_ZONES'
export const LOAD_AVAILABLE_STATUS = 'LOAD_AVAILABLE_STATUS'
export const LOAD_FREQUENCY_ENUM = 'LOAD_FREQUENCY_ENUM'
export const LOAD_RECURRENCE_LIMIT_ENUM = 'LOAD_RECURRENCE_LIMIT_ENUM'
export const LOAD_RECURRENCE_FREQUENCY_ENUM = 'LOAD_RECURRENCE_FREQUENCY_ENUM'